import { IAvailableDays } from 'modules/api-requests/waitlist/types';
import type { RuleObject } from 'rc-field-form/lib/interface';

export const weekDaysValidator = (rule: RuleObject, value: IAvailableDays) => {
  return Object.values(value).some((x) => !!x) ? Promise.resolve() : Promise.reject();
};

